import React from 'react';
import './Infrastructure.css';

const Infrastructure = () => {
  const infrastructureImages = [
    '/assets/infrastructure/1.jpg',
    '/assets/infrastructure/2.jpg',
    '/assets/infrastructure/3.jpg',
    '/assets/infrastructure/4.jpg',
    '/assets/infrastructure/5.jpg',
    '/assets/infrastructure/6.jpg',
    '/assets/infrastructure/8.jpg',
    '/assets/infrastructure/11.jpg',
    '/assets/infrastructure/12.jpg',
  ];

  const processSteps = [
    {
      step: 1,
      title: 'Raw Material Receipt',
      description: 'Careful inspection and quality assessment of incoming raw materials.',
      icon: 'fa-truck'
    },
    {
      step: 2,
      title: 'Initial Cleaning',
      description: 'Removal of foreign matter and initial cleaning processes.',
      icon: 'fa-shower'
    },
    {
      step: 3,
      title: 'Shelling Process',
      description: 'Efficient shelling using advanced decorticator machines.',
      icon: 'fa-cogs'
    },
    {
      step: 4,
      title: 'Grading & Sorting',
      description: 'Size-based grading and quality sorting of processed peanuts.',
      icon: 'fa-filter'
    },
    {
      step: 5,
      title: 'Quality Testing',
      description: 'Comprehensive quality testing and certification processes.',
      icon: 'fa-flask'
    },
    {
      step: 6,
      title: 'Packaging & Storage',
      description: 'Final packaging and storage in controlled conditions.',
      icon: 'fa-box'
    }
  ];


  return (
    <div className="infrastructure-page">
      {/* Hero Section */}
      <section className="infrastructure-hero">
        <div className="hero-background"></div>
        <div className="hero-gradient"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <h1>Infrastructure</h1>
              <p className="lead">
                The Technology makes it all work to give you the Finest Quality.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Infrastructure Overview */}
      <section className="section infrastructure-overview">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="infrastructure-content">
                <p>
                  At SVG, our state-of-the-art infrastructure is well equipped with advanced and necessary expertise required during different stages of processing and packaging of peanuts. Our facility is spread across a wide area of 16000 sq. ft. that includes:
                </p>
                <ul className="infrastructure-list">
                  <li>Decorticator Machines for Separation from Peanuts in-shells into Peanuts.</li>
                  <li>Graders for the Grading of Peanuts.</li>
                  <li>Conveyors & 4 Mixers for mixing Peanuts.</li>
                  <li>Advanced sortex.</li>
                  <li>Packaging facility.</li>
                  <li>Machines for grading.</li>
                </ul>
              </div>
            </div>
            <div className="col-md-4">
              <div className="infrastructure-office-image">
                <img 
                  src="/assets/infrastructure/office.jpg" 
                  alt="SVG Office Infrastructure" 
                  className="img-responsive"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Gujarat Unit Section */}
      <section className="section gujarat-unit">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-header text-center">
                <h2>Gujarat Unit</h2>
                <p className="lead">
                  Our state-of-the-art Gujarat facility represents the pinnacle of modern infrastructure and processing capabilities.
                </p>
              </div>
            </div>
          </div>
          
          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="gujarat-unit-card">
                <div className="gujarat-image">
                  <img 
                    src="/assets/infrastructure/guj-01.jpg" 
                    alt="Gujarat Unit - Modern Infrastructure" 
                    className="img-responsive"
                  />
                  <div className="image-overlay">
                    <div className="overlay-content">
                      <h4>Modern Infrastructure</h4>
                      <p>Advanced processing facility in Gujarat</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="col-md-6 mb-4">
              <div className="gujarat-unit-card">
                <div className="gujarat-image">
                  <img 
                    src="/assets/infrastructure/guj-02.jpg" 
                    alt="Gujarat Unit - Processing Equipment" 
                    className="img-responsive"
                  />
                  <div className="image-overlay">
                    <div className="overlay-content">
                      <h4>Processing Equipment</h4>
                      <p>State-of-the-art machinery and technology</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </section>

      {/* Infrastructure Images */}
      <section className="section infrastructure-images">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-header text-center">
                <h2>Processing Unit</h2>
                <p className="lead">
                  Explore our state-of-the-art processing facilities and advanced machinery that ensure the highest quality peanut processing.
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            {infrastructureImages.map((image, index) => (
              <div key={index} className="col-md-4 col-lg-4 mb-4">
                <div className="infrastructure-image-item">
                  <img src={image} alt={`Infrastructure ${index + 1}`} className="img-responsive" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Processing Steps */}
      <section className="section processing-steps">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h2 className="mb-4">Our Processing Steps</h2>
              <p className="lead mb-4">
                Discover our detailed peanut processing journey with step-by-step insights.
              </p>
              <a href="/quality#processing-steps" className="btn btn-primary btn-lg">
                <i className="fa fa-arrow-right"></i>
                View Detailed Processing Steps
              </a>
            </div>
          </div>
        </div>
      </section>


      {/* Technology Highlights */}
      <section className="section technology-highlights">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="technology-content">
                <h2>Advanced Technology</h2>
                <p className="lead">
                  We utilize cutting-edge technology and machinery to ensure the highest quality 
                  and efficiency in our processing operations.
                </p>
                <div className="tech-features">
                  <div className="tech-item">
                    <i className="fa fa-cogs"></i>
                    <div>
                      <h4>Automated Processing</h4>
                      <p>Fully automated processing systems for consistent quality and efficiency.</p>
                    </div>
                  </div>
                  <div className="tech-item">
                    <i className="fa fa-shield"></i>
                    <div>
                      <h4>Quality Control</h4>
                      <p>Advanced quality control systems ensuring international standards.</p>
                    </div>
                  </div>
                  <div className="tech-item">
                    <i className="fa fa-leaf"></i>
                    <div>
                      <h4>Eco-Friendly</h4>
                      <p>Environmentally friendly processes and waste management systems.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="technology-image">
                <img 
                  src="/assets/infrastructure/9.jpg" 
                  alt="Advanced Technology" 
                  className="img-responsive"
                />
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Contact for Infrastructure */}
      <section className="section contact-infrastructure">
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <div className="contact-content">
                <h2>Infrastructure Inquiries</h2>
                <p style={{ color: 'black' }}>
                  For detailed information about our infrastructure, facility tours, or technical 
                  specifications, please contact our operations team.
                </p>
                <div className="contact-info">
                  <div className="contact-item whatsapp-contact">
                    <svg className="whatsapp-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
                    </svg>
                    <a href="https://wa.me/919448165266?text=Hello! I'm interested in your infrastructure and facility details. Could you please provide more information?" target="_blank" rel="noopener noreferrer">+91 944 816 5266</a>
                  </div>
                  <div className="contact-item">
                    <i className="fa fa-envelope"></i>
                    <span>svgadag_12@yahoo.com</span>
                  </div>
                  <div className="contact-item">
                    <i className="fa fa-phone"></i>
                    <span>+91 944 816 5266</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="contact-cta">
                <h3 style={{ color: 'white' }}>Schedule a Visit</h3>
                <p style={{ color: 'white' }}>Arrange a facility tour to see our infrastructure firsthand.</p>
                <a href="/contact-us" className="btn btn-primary">Contact Us</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Infrastructure;
